// import * as Sentry from '@sentry/browser';
import '@fontsource-variable/inter';
import './styles/app.css';

// Window extensions
import './js/extensions';

// Error handlers for Turbo and global errors
import './js/error-handlers';

// start the Stimulus application
import './bootstrap';

const version = require('../package.json').version;

window.playerVersion = version;

// window.onload = () => {
//     Sentry.init({
//         dsn: 'https://de910e378e514c7bb499994e82644f5b@o69286.ingest.sentry.io/148116',
//         environment: window.env,
//         ignoreErrors: [
//             'ChunkLoadError',
//             'AbortError',
//             'The play method is not allowed',
//             'sendBeacon',
//             // Don't report routine Load failed errors to Sentry
//             /Load failed/i,
//             // Network errors that are often user-related
//             /NetworkError/i,
//             /Failed to fetch/i,
//         ],
//         denyUrls: [
//             /static\.cloudflareinsights\.com/i,
//             /www\.gstatic\.com/i,
//             // Chrome extensions
//             /extensions\//i,
//             /^chrome:\/\//i,
//         ],
//         beforeSend(event) {
//             // Add additional context for load failures
//             if (event.exception?.values?.[0]?.value?.includes('Load failed')) {
//                 event.tags = {
//                     ...event.tags,
//                     error_type: 'load_failure',
//                     network_status: navigator.onLine ? 'online' : 'offline',
//                 };
//             }
//             return event;
//         },
//     });
//
//     if (window.user.email) {
//         Sentry.setUser({email: window.user.email});
//     }
// };
